import { jsx as _jsx } from "react/jsx-runtime";
import useResponsive from "../util/useResponsive";
import AddCommentButtonDesktop from "./AddCommentButtonDesktop";
import AddCommentButtonMobile from "./AddCommentButtonMobile";
const AddCommentButton = (props) => {
    const { isSmallScreen } = useResponsive();
    return isSmallScreen ? (_jsx(AddCommentButtonMobile, Object.assign({}, props))) : (_jsx(AddCommentButtonDesktop, Object.assign({}, props)));
};
export default AddCommentButton;
